<script setup lang="ts">
const props = defineProps({
  file: null,
  background: { type: Boolean },
  selectable: { type: Boolean },
  location: null
})

const { selectFile, isSelectedIn } = useSelection()
const { navigateToFile } = useNavigation()

const selected = computed(() => isSelectedIn(props.file.fileId, "agent"))
const selectedHere = ref(false)

const onClickedFile = () => {
  if (!props.selectable)
    return
  if (selectedHere.value) {
    navigateToFile(props.file)
    selectedHere.value = false
  }
  else {
    if (!isDefined(props.location))
      throw new Error("Location not defined")
    selectFile(props.file, props.location)
    selectedHere.value = true
  }
}
watch(selected, (isSelected) => {
  if (!props.selectable)
    return
  if (!isSelected)
    selectedHere.value = false
})
</script>

<template>
  <div
    class="file-inline"
    :class="{ selectable, selected, selectedHere, background }"
    @click="onClickedFile()"
  >
    <div class="file-thumbnail-container" :style="{ width: px(16), height: px(16) }">
      <file-thumbnail
        class="file-thumbnail"
        :file
        :container-height="16"
        :container-width="16"
        cropped
      />
    </div>
    <span class="name">{{ file.name() }}</span>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.file-inline
  max-width: min(100%, 250px)
  @apply inline-flex items-center gap-0.75 min-w-0
  @apply p-0.5 pl-1 rounded-[6px] vertical-bottom
  &.selectable
    @apply cursor-pointer
    &:hover
      @apply bg-[#{$panel-agent-bg-file-hover}]
    &.background:not(:hover):not(.selectedHere)
      @apply bg-[#{$panel-agent-bg-file-inline-bubble}]
    &.selectedHere
      @apply bg-$global-blue-primary

.file-thumbnail
  @apply h-4 w-4 aspect-square flex-none
.name
  @apply text-ellipses-inline max-w-full pr-1
</style>
